import styled from 'styled-components';

export const PaginationWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const PageButton = styled.button`
  margin: 0 5px;
  padding: 5px 10px;
  border: none;
  border-radius: 3px;
  background-color: #ddd;
  &:hover {
    background-color: #bbb;
    cursor: pointer;
  }
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    background-color: #ddd;
    &:hover {
      background-color: #ddd;
    }
  }
`;

export const CurrentPageButton = styled(PageButton)`
  background-color: #bbb;
  font-weight: bold;
  &:disabled {
    background-color: #bbb;
    &:hover {
      background-color: #bbb;
    }
  }
`;